<p-table
    [columns]="cols"
    [value]="dataTable"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [scrollable]="true" 
    [resizableColumns]="true"
    [(selection)]="selected"
    selectionMode="single"
    (onRowSelect)="isNotRowSelected=false"
    (onRowUnselect)="isNotRowSelected=true"
    [styleClass]="styleClass"
    [responsive]="true"
    [paginator]="paginator" [lazy]="lazy" [(first)]="first" (onLazyLoad)="paginationEmitter($event)">

    <ng-template pTemplate="header" let-columns>
        <tr>
            <th scope="col" *ngFor="let col of columns"  pResizableColumn>
                {{col.header | translate}}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="index" >
            <td *ngFor="let col of columns">
                <span class="p-column-title">
                    {{col.header}}
                </span>                
                {{rowData[col.field] | checkEmpty}}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
		<tr>
			<td [attr.colspan]="columns.length">
				{{'TABLA.sinresultados' | translate}}
			</td>
		</tr>
    </ng-template>

    <ng-template pTemplate="summary" class="p-mt-5">
		<div class="p-grid p-justify-end p-mt-2">

            <ng-content></ng-content>

            <button *ngIf="hasDetail" pButton class="p-mr-2" type="button" [icon]="'fa fa-info-circle'"
                [disabled]="isNotRowSelected" label="{{ 'DETAIL' | translate }}" (click)="detailEmitter()">
            </button>

            <button *ngIf="hasDelete" pButton class="p-mr-2" type="button" [icon]="'fa fa-trash'" [disabled]="isNotRowSelected"
                label="{{ 'DELETE' | translate }}" (click)="deleteEmitter()">
            </button>

            <button pButton type="button" [icon]="'fa fa-edit'" [disabled]="isNotRowSelected" *ngIf="hasEdit"
                label="{{ 'EDIT' | translate }}" (click)="editEmitter()">
            </button>
		</div>
	</ng-template>
</p-table>
